/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoreSignupPaymentMethodMutationVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
  paymentMethod: GraphQL.Scalars['Array']['input'];
}>;


export type StoreSignupPaymentMethodMutation = { readonly __typename?: 'Mutation', readonly StorePaymentMethod: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly paymentMethod: { readonly __typename?: 'AccountPaymentMethod', readonly details: Record<string, any>, readonly type: string } | null } | null } } };


export const StoreSignupPaymentMethodDocument = gql`
    mutation StoreSignupPaymentMethod($accountId: AccountId!, $paymentMethod: Array!) {
  StorePaymentMethod(accountId: $accountId, paymentMethod: $paymentMethod) {
    query {
      account(id: $accountId) {
        id
        paymentMethod {
          details
          type
        }
      }
    }
  }
}
    `;
export type StoreSignupPaymentMethodMutationFn = Apollo.MutationFunction<StoreSignupPaymentMethodMutation, StoreSignupPaymentMethodMutationVariables>;

/**
 * __useStoreSignupPaymentMethodMutation__
 *
 * To run a mutation, you first call `useStoreSignupPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreSignupPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeSignupPaymentMethodMutation, { data, loading, error }] = useStoreSignupPaymentMethodMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useStoreSignupPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<StoreSignupPaymentMethodMutation, StoreSignupPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreSignupPaymentMethodMutation, StoreSignupPaymentMethodMutationVariables>(StoreSignupPaymentMethodDocument, options);
      }
export type StoreSignupPaymentMethodMutationHookResult = ReturnType<typeof useStoreSignupPaymentMethodMutation>;
export type StoreSignupPaymentMethodMutationResult = Apollo.MutationResult<StoreSignupPaymentMethodMutation>;
export type StoreSignupPaymentMethodMutationOptions = Apollo.BaseMutationOptions<StoreSignupPaymentMethodMutation, StoreSignupPaymentMethodMutationVariables>;